module.exports = __webpack_public_path__ + "b8c041c3a810ceb39bfe53203ba82c48.png";